import { Checkbox, Input, Modal } from '@bp/ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBottomButtons } from '../../ModalBottomButtons/ModalBottomButtons';
import { TeachingBlockVersion } from '../TeachingBlockVersionsOverview/TeachingBlockVersionsOverview';

type TeachingBlockVersionModalFormProps = {
  editVersion?: TeachingBlockVersion | null;
  onSave: (editVersion: Partial<TeachingBlockVersion>) => void;
  onClose: () => void;
  loading: boolean;
};

export const TeachingBlockVersionModalForm = ({
  editVersion,
  onSave,
  onClose,
  loading,
}: TeachingBlockVersionModalFormProps) => {
  const { t } = useTranslation();

  const [description, setDescription] = useState<string>('');
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    setDescription(editVersion?.description ?? '');
    setActive(editVersion?.active ?? false);
  }, [editVersion]);

  return (
    <Modal
      title={t('teachingBlockVersion.edit', { version: editVersion?.version })}
      width='s'
      isOpen={!!editVersion}
      onRequestClose={() => onClose()}
      style={{ overlay: { zIndex: 100 } }}
    >
      <div className='tks__grid no-wrap'>
        <div className='tks__col col-xs-10'>
          <Input
            label={t('common.name')}
            value={description}
            onChange={(value) => setDescription(value.target.value)}
            name='name'
          />
        </div>
        <div className='tks__col col-xs-2 row align-center bottom-xs'>
          <Checkbox
            label={t('common.active.full')}
            name='isActive'
            checked={active}
            onChange={(value) => setActive(value.target.checked)}
          />
        </div>
      </div>
      <ModalBottomButtons
        closeButton={{ callback: () => onClose() }}
        submitButton={{
          callback: () => onSave({ ...editVersion, active, description }),
          disabled: !editVersion?.uuid,
        }}
        isLoading={loading}
        errors={undefined}
      />
    </Modal>
  );
};
